module.exports = __webpack_public_path__ + "img/menu-help-center.0a0a389.svg";